export const defaultMessages = {
  upload_success: 'Arquivo enviado com sucesso!',
  upload_failed:
    'Não foi possível realizar o envio do arquivo. Tente novamente!',
  download_failed: 'Não foi possível baixar o arquivo. Tente novamente!',
  generic_error:
    'Ocorreu um problema ao realizar essa operação. Tente novamente!',
  generic_success: 'Operação realizada com sucesso!'
};
